<template>
  <v-card link flat :class="item.IsActive ? '' : 'deactivated'" class="rounded-0" @click="$emit('click')">
    <v-row no-gutters class="px-3" align="center">
      <v-col cols="auto" class="pr-3">
        <CustomerGroupImage :relative-path="item.Image" :size="35"></CustomerGroupImage>
      </v-col>
      <v-col cols="auto" class="pr-3 py-2" style="opacity: 0.7">
        {{ item.Id }}
      </v-col>
      <v-col cols="7" class="py-2">
        {{ item.Name }}
      </v-col>
      <v-col :class="item.CustomerCount ? '' : 'disabled--text'" class="py-2">
        <v-icon size="20" :color="item.CustomerCount ? '' : 'disabled'">mdi-link</v-icon>
        {{ item.CustomerCount }}
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
import CustomerGroupImage from '@/views/customer/group/CustomerGroupImage.vue';

export default {
  name: 'CustomerGroupListItem',
  props: {
    item: Object,
  },
  components: {
    CustomerGroupImage,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>